import { PlayIcon } from '@components/Icons/PlayIcon';
import NapsterSpinner from '@components/NapsterSpinner';

interface GradientButtonProps {
  icon?: string;
  title?: string;
  onClickHandle?: () => void;
  disabled?: boolean;
  isAnimating?: boolean;
}

export const GradientButton = (props: GradientButtonProps) => {
  const {
    icon,
    title,
    onClickHandle,
    disabled = false,
    isAnimating = false,
  } = props;

  const onclickHandle = () => {
    if (onClickHandle && !disabled) {
      onClickHandle();
    }
  };
  return (
    <>
      <style>
        {`
                    @property --rotation {
                        syntax: '<angle>';
                        initial-value: 0deg;
                        inherits: false;
                    }
                    
                    @keyframes rotate-gradient-angle {
                        from {
                            --rotation: 0deg;
                        }
                        to {
                            --rotation: 360deg;
                        }
                    }
                    
                    .gradient-btn:hover:not(:disabled) .gradient-border,
                    .gradient-btn.animating .gradient-border {
                        animation: rotate-gradient-angle 1s linear infinite;
                    }

                    .gradient-btn:disabled {
                        cursor: not-allowed !important;
                        pointer-events: auto;
                    }

                    .gradient-border {
                        mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
                        mask-composite: xor;
                        -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
                        -webkit-mask-composite: xor;
                        padding: 2px;
                    }
                `}
      </style>
      <button
        onClick={onclickHandle}
        disabled={disabled}
        className={`gradient-btn ${
          isAnimating ? 'animating' : ''
        } relative flex  items-center gap-[6px] py-3 px-4 h-[32px] rounded-full bg-clip-padding text-white text-[12px] font-semibold leading-[130%] font-[NapsterSans] transition-all duration-300 ${
          disabled ? 'opacity-60 cursor-not-allowed' : ''
        }`}>
        {/* Rotating Gradient Border */}
        <div
          className="gradient-border"
          style={
            {
              position: 'absolute',
              top: '-2px',
              left: '-2px',
              right: '-2px',
              bottom: '-2px',
              pointerEvents: 'none',
              borderRadius: 'inherit',
              '--rotation': '0deg',
              background:
                disabled && !isAnimating
                  ? '#6B7280'
                  : 'conic-gradient(from calc(0deg + var(--rotation)), var(--Tertiary, #F6911D) 0deg, var(--Secondary, #FF04FF) 120deg, var(--Primary, #0FF) 240deg, var(--Tertiary, #F6911D) 360deg)',
              zIndex: 0,
            } as React.CSSProperties & { '--rotation': string }
          }
        />

        {/* Background */}
        <div className="absolute left-0 top-0 right-0 bottom-0 hover:bg-[#000000]/80 bg-[#000000]/20 rounded-full"></div>

        <div className="relative flex items-center gap-[6px]">
          {/* Icon */}
          {icon === 'play' && <PlayIcon />}
          {icon === 'loading' && <NapsterSpinner size="small" />}

          {/* Title */}
          {title}
        </div>
      </button>
    </>
  );
};
